<template>
    <div class="social-media">
        <a href="#facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
        <a href="#instagram" target="_blank"><i class="fab fa-instagram"></i></a>
        <a href="#youtube" target="_blank"><i class="fab fa-youtube"></i></a>
        <a v-if="this.langs ==='es'" href="../../en/" ><i class="fas fa-flag"></i><span class="on">EN</span></a>
        <a v-else href="../../es/" ><i class="fas fa-flag"></i><span class="on">ES</span></a>
    </div>
</template>

<script>
export default {
    name: 'Social',
    data() {
        return {
            langs: null,
        }
    },
    created() {
        var url =  window.location.href;

        url = url.split('/');

        url.forEach(element => {
           if(element === 'es'){
               this.langs = 'es';
           }else if(element === 'en'){
               this.langs = 'en';
           }
        });

        if(this.langs === null)
            this.langs = 'es';
    },
}
</script>